<template>
  <v-snackbar
    v-bind="$attrs"
    v-on="$listeners"
    top
    right
    :timeout="timeout"
    :color="color"
    class="premium-snackbar"
    content-class="premium-snackbar__content"
  >
    <div class="snack-inner">
      <div class="snack-left">
        <v-icon class="snack-icon" color="white">
          {{ icon }}
        </v-icon>

        <div class="snack-text">
          {{ message || "Error!" }}
        </div>
      </div>
    </div>

    <!-- ✅ Slot tem de estar ao nível root dentro do v-snackbar -->
    <template v-slot:action="{ attrs }">
      <v-btn
        icon
        v-bind="attrs"
        @click="close"
        class="snack-close"
        aria-label="Fechar"
      >
        <v-icon color="white">mdi-close</v-icon>
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
export default {
  props: {
    message: String,
    color: {
      type: String,
      default: "error"
    },
    timeout: {
      type: Number,
      default: 2000
    }
  },
  computed: {
    icon () {
      const c = (this.color || "").toString()
      if (c.includes("success")) return "mdi-check-circle-outline"
      if (c.includes("warning")) return "mdi-alert-outline"
      if (c.includes("info")) return "mdi-information-outline"
      return "mdi-alert-circle-outline"
    }
  },
  methods: {
    close () {
      this.$emit("input", false)
    }
  }
}
</script>

<style scoped>
.premium-snackbar {
  border-radius: 16px !important;
  overflow: hidden;
  box-shadow: 0 18px 55px rgba(0, 0, 0, 0.28) !important;
}

.premium-snackbar__content {
  padding: 0 !important;
}

.premium-snackbar::before {
  content: "";
  display: block;
  height: 4px;
  background: rgba(255, 255, 255, 0.35);
}

.snack-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 14px;
}

.snack-left {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

.snack-icon {
  opacity: 0.95;
}

.snack-text {
  color: #fff;
  font-weight: 600;
  font-size: 14px;
  line-height: 1.35;
  letter-spacing: 0.2px;
  white-space: pre-line;
  overflow: hidden;
  text-overflow: ellipsis;
}

.snack-close {
  border-radius: 12px;
  transition: background 0.15s ease;
}

.snack-close:hover {
  background: rgba(255, 255, 255, 0.14);
}
</style>
